import React from "react";
import Typography from "@material-ui/core/Typography";
import useLongPress from "./useLongPress";

export const SpeakItem = (props) => {
  const {
    word,
    languageText,
    voice,
    handleTextSpeakClick,
    UpdateField,
    variant,
  } = props;
  let explicit = false;
  if (word && word.speakExplicit && word.speakExplicit.length) {
    explicit = word.speakExplicit.includes(languageText);
  }

  let className = "MySpeakText " + (explicit === true ? "orange" : "");

  const onLongPress = () => {
    if (word && word.speakExplicit && word.speakExplicit.length) {
      let temp = word.speakExplicit;
      if (word.speakExplicit.includes(languageText)) {
        temp.splice(temp.indexOf(languageText), 1);
      } else {
        temp.push(languageText);
      }
      if (temp.length > 0) {
        UpdateField("speakExplicit", temp);
      } else {
        UpdateField("speakExplicit", null);
      }
    } else {
      UpdateField("speakExplicit", [languageText]);
    }
  };

  const onClick = () => {
    handleTextSpeakClick(word[languageText], voice, true);
  };

  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 1500,
  };
  const longPressEvent = useLongPress(onLongPress, onClick, defaultOptions);

  if (!word) {
    return <></>;
  }
  return (
    <Typography
      // onClick={() => handleTextSpeakClick(word[languageText], voice, true)}
      {...longPressEvent}
      className={className}
      variant={variant}
      gutterBottom
    >
      {word[languageText]}
    </Typography>
  );
};
